import React from 'react';

// App-wide crash guard. Without this, any uncaught render error unmounts the whole
// React tree and leaves a blank white screen (a broker reported exactly this on login).
// Instead we show a usable recovery screen AND report the error + stack to the server
// (/api/client-error) so "who white-screened and why" is answerable from the logs.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    try {
      const token = localStorage.getItem('vroia-token');
      fetch('/api/client-error', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) },
        body: JSON.stringify({
          message: String(error && (error.message || error)),
          stack: String(error && error.stack || ''),
          componentStack: String(info && info.componentStack || ''),
          url: window.location.href,
        }),
        keepalive: true,
      }).catch(() => {});
    } catch (e) { /* best-effort */ }
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    const logout = () => { try { localStorage.removeItem('vroia-token'); localStorage.removeItem('vroia-user'); } catch (e) {} window.location.href = '/'; };
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24, background: 'var(--bg-primary, #f8fafc)', color: 'var(--text-primary, #0f172a)' }}>
        <div style={{ maxWidth: 440, textAlign: 'center' }}>
          <div style={{ fontSize: '2.4rem', marginBottom: 12 }}>&#9888;</div>
          <h1 style={{ fontSize: '1.2rem', fontWeight: 800, margin: '0 0 8px' }}>حدث خطأ غير متوقع</h1>
          <div style={{ fontSize: '0.95rem', opacity: 0.75, marginBottom: 6 }}>Something went wrong. Please reload the page.</div>
          <div style={{ fontSize: '0.9rem', opacity: 0.75, marginBottom: 20, direction: 'rtl' }}>حدث خطأ أثناء عرض الصفحة. الرجاء إعادة التحميل.</div>
          <div style={{ display: 'flex', gap: 10, justifyContent: 'center', flexWrap: 'wrap' }}>
            <button onClick={() => window.location.reload()} style={{ padding: '10px 22px', borderRadius: 8, border: 'none', background: '#2563eb', color: '#fff', fontWeight: 700, cursor: 'pointer', fontSize: '0.9rem' }}>إعادة التحميل · Reload</button>
            <button onClick={logout} style={{ padding: '10px 22px', borderRadius: 8, border: '1px solid #cbd5e1', background: 'transparent', color: 'inherit', fontWeight: 700, cursor: 'pointer', fontSize: '0.9rem' }}>تسجيل الخروج · Log out</button>
          </div>
        </div>
      </div>
    );
  }
}
